<div class="flex flex-column">
  <h3 class="text-center text-red-500"><span *ngIf="search" class="">"{{search}}" </span>No se encontraron productos.</h3>
</div>
